var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#007cbc}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20.8,
    cy: 20.3,
    r: 6.1,
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9,60.8h-6.3c-1.1,0-1.9-0.9-1.9-1.9V32.3c0-1.1,0.9-1.9,1.9-1.9h6.3c1.1,0,1.9,0.9,1.9,1.9v26.5 C25.8,59.9,25,60.8,23.9,60.8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2,41.5v17.2c0,1.1-0.9,2-2,2h-6.1c-1.1,0-2-0.9-2-2V44.6c0-2.8-2.3-5.1-5.1-5.1c-2.8,0-5.1,2.3-5.1,5.1 v14.2c0,1.1-0.9,2-2,2h-6.1c-1.1,0-2-0.9-2-2V32.4c0-1.1,0.9-2,2-2H38c1.1,0,2,0.9,2,2v1.3c2-2.6,5.4-4.3,9.1-4.3 C54.7,29.4,60.2,33.5,60.2,41.5z",
    className: "st0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3034f41cf677c36314be7865db9006ad.svg";
export { ForwardRef as ReactComponent };